import contentSettings from '@site/content.settings'

const GOOGLE_CONSENT_MODE_DEFAULTS_ID = 'CookiebotGoogleConsentModeDefaults'
const GOOGLE_CONSENT_MODE_DEFAULTS_HID = 'cookiebot-google-consent-mode-defaults'
const GOOGLE_CONSENT_MODE_DEFAULTS_SCRIPT = `
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag('consent', 'default', {
  'ad_personalization': 'denied',
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'analytics_storage': 'denied',
  'functionality_storage': 'denied',
  'personalization_storage': 'denied',
  'security_storage': 'granted',
  'wait_for_update': 500,
});
gtag('set', 'ads_data_redaction', true);
gtag('set', 'url_passthrough', false);
`.trim()

export default function({ app }) {
  const { cookieBot } = contentSettings

  if (process.client) {
    return
  }

  const scripts = app.head.script || []
  app.head.script = scripts
  const isCookiebotLoaded = scripts.some(
    script =>
      script.id === 'Cookiebot' || script.hid === 'cookiebot' || script.src === 'https://consent.cookiebot.com/uc.js',
  )
  const isGoogleConsentModeDefaultsLoaded = scripts.some(
    script => script.id === GOOGLE_CONSENT_MODE_DEFAULTS_ID || script.hid === GOOGLE_CONSENT_MODE_DEFAULTS_HID,
  )

  if (!cookieBot || !cookieBot.cbid) {
    return
  }

  if (!isCookiebotLoaded) {
    // Async keeps uc.js off the critical rendering path (allowed in manual blocking mode; consent consumers
    // in app/cookiebot.js wait for Cookiebot events). The overlay script must stay before it to catch the dialog event.
    const overlayIndex = scripts.findIndex(script => script.hid === 'cookiebot-overlay')
    scripts.splice(overlayIndex + 1, 0, {
      hid: 'cookiebot',
      src: 'https://consent.cookiebot.com/uc.js',
      async: true,
      ['data-cbid']: cookieBot.cbid,
      ['data-blockingmode']: 'manual',
      type: 'text/javascript',
      id: 'Cookiebot',
    })
  }

  if (!isGoogleConsentModeDefaultsLoaded) {
    const cookiebotIndex = scripts.findIndex(
      script =>
        script.id === 'Cookiebot' || script.hid === 'cookiebot' || script.src === 'https://consent.cookiebot.com/uc.js',
    )

    scripts.splice(cookiebotIndex + 1, 0, {
      hid: GOOGLE_CONSENT_MODE_DEFAULTS_HID,
      id: GOOGLE_CONSENT_MODE_DEFAULTS_ID,
      innerHTML: GOOGLE_CONSENT_MODE_DEFAULTS_SCRIPT,
      type: 'text/javascript',
      ['data-cookieconsent']: 'ignore',
    })

    const sanitizers = app.head.__dangerouslyDisableSanitizers || []
    if (!sanitizers.includes('script')) {
      app.head.__dangerouslyDisableSanitizers = [...sanitizers, 'script']
    }
  }
}
